export function addPrefetchToLinks() {
    const links = document.querySelectorAll("a"); // Selecciona todos los enlaces en la página
    const currentHost = window.location.host; // Obtiene el dominio actual

    links.forEach(link => {
        if (
            !link.hasAttribute("data-prefetch") && // Evita duplicados
            link.host === currentHost && // Solo aplica a enlaces internos
            link.href.startsWith("http") && // Evita enlaces con `#` o `mailto:`
            link.getAttribute("data-prefetch") !== "false" // No agregar si es `false`
        ) {
            link.setAttribute("data-prefetch", "true");
        }
    });
}
